import { SVGProps } from "react";

type SvgProps = SVGProps<SVGSVGElement> & { strokeWidth?: string | number };

export const LongArrowRight = ({ strokeWidth = "2", ...props }: SvgProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 8.5636H13.5"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 4.0636L13.5 8.5636L9 13.0636"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
